import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";
import {
  errorNotify,
  infoNotify,
  successNotify,
} from "../../Components/ToastComponent/ToastNotification";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
  Link,
  Avatar,
  InputAdornment,
  IconButton,
} from "@mui/material";

import { Visibility, VisibilityOff, Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import bglogo from "../../Assets/Images/bglogin.jpg";
import logo from "../../Assets/Images/f00c31d28a1eab4518d447421a5689b4f924c23b.png";
import avatar from "../../Assets/Images/loginavatar.png";
import TextInput from "../../Components/InputComponents/TextInput";

const LoginPage = ({ setRole, loginUser }) => {
  const navigate = useNavigate();

  const [otp, setOtp] = useState(new Array(6).fill(""));

  const inputsRef = useRef([]);

  const [view, setView] = useState("login"); // login | forgot | otp | changepass
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [ConfirmPass, setConfirmPass] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberPassword, setRememberPassword] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (element, index) => {
    const value = element.value.replace(/\D/g, ""); // Only digits
    if (value) {
      const updatedOtp = [...otp];
      updatedOtp[index] = value;
      setOtp(updatedOtp);

      // Move focus
      if (index < 5) {
        inputsRef.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const updatedOtp = [...otp];
        updatedOtp[index] = "";
        setOtp(updatedOtp);
      } else if (index > 0) {
        inputsRef.current[index - 1].focus();
      }
    }
  };

  const handleRememberChange = (event) => {
    setRememberPassword(event.target.checked);
  };

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = () => {
    if (!username || !password) {
      toast.error("Please enter both Username and Password!");
      return;
    }

    const config = {
      admin: {
        url: "/Employee/login",
        payload: {
          ED_UserName: username,
          ED_Password: password,
        },
      },
      candidate: {
        url: "/Candidate/login",
        payload: {
          CI_UserName: username,
          CI_Password: password,
        },
      },
      client: {
        url: "/Client/login",
        payload: {
          CD_UserName: username,
          CD_Password: password,
        },
      },
    };

    const current = config[loginUser?.toLowerCase()];

    if (!current) {
      errorNotify("Invalid user role selected");
      return;
    }

    setIsLoading(true);

    axiosAPI
      .post(current.url, current.payload)
      .then((res) => {
        if (res?.data?.data?.token) {
          localStorage?.setItem("SWA_RememberPassword", rememberPassword); // To store Remember me status / checkbox value
          localStorage?.setItem("SWA_RememberPassword_loginUser", loginUser); // To Remember last logged in user, for Routing

          if (rememberPassword) {
            localStorage.setItem("SWA_userRole", loginUser); // user role
            localStorage.setItem("SWA_token", res?.data?.data?.token); // token
            localStorage.setItem("SWA_UserId", res?.data?.data?.User_Id); // user id
            localStorage.setItem("SWA_IsAdmin", res?.data?.data?.ED_Admin); // to check if user is admin or not

            // ✅ Store credentials if Remember Me is checked
            localStorage.setItem("SWA_RememberedUsername", username);
            localStorage.setItem("SWA_RememberedPassword", password);
          } else {
            sessionStorage.setItem("SWA_userRole", loginUser); // user role
            sessionStorage.setItem("SWA_token", res?.data?.data?.token); // token
            sessionStorage.setItem("SWA_UserId", res?.data?.data?.User_Id); // user id
            sessionStorage.setItem("SWA_IsAdmin", res?.data?.data?.ED_Admin); // to check if user is admin or not

            // ❌ Clear stored credentials if Remember Me is not checked
            localStorage.removeItem("SWA_RememberedUsername");
            localStorage.removeItem("SWA_RememberedPassword");
          }
          successNotify("Logged in Successfully");
          setRole(loginUser);
          navigate("/");
        } else {
          errorNotify("Invalid Credentials");
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        errorNotify("Something went Wrong!");
      });
  };

  const handleForgotPassword = async () => {
    if (!username) return alert("Username required");
    setIsLoading(true);

    await axiosAPI
      ?.post(`/Employee/forgot-password`, {
        ED_UserName: username,
      })
      .then((res) => {
        if (res?.data?.success) {
          if (res?.data?.data?.success) {
            successNotify(res?.data?.data?.message);
            setView("otp");
          } else {
            errorNotify(res?.data?.data?.message);
          }
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        errorNotify("Something went Wrong!");
      });
  };

  const handleVerifyOtp = async () => {
    const finalOtp = otp.join("");

    if (finalOtp?.toString()?.length !== 6) {
      infoNotify("Enter valid 6-digit OTP");
    } else {
      await axiosAPI
        ?.post(`/Employee/otpValidation`, {
          ED_UserName: username,
          otp: finalOtp,
        })
        .then((res) => {
          if (res?.data?.success) {
            if (res?.data?.data?.success) {
              successNotify(res?.data?.data?.message);
              setView("confirmpass");
            } else {
              errorNotify(res?.data?.data?.message);
            }
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          errorNotify("Something went Wrong!");
        });
    }
  };

  const handlePasswordChange = async () => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

    if (password == ConfirmPass) {
      if (password?.length < 8) {
        infoNotify("Password must have at least 8 characters.");
      } else if (!passwordRegex.test(password)) {
        infoNotify(
          "Password must have atleast one uppercase, lowercase, number, and special character."
        );
      } else {
        await axiosAPI
          ?.post(`/Employee/reset-password`, {
            ED_UserName: username,
            newPassword: password,
          })
          .then((res) => {
            if (res?.data?.success) {
              if (res?.data?.data?.success) {
                successNotify(res?.data?.data?.message);
                setUsername("");
                setPassword("");
                setView("login");
              } else {
                errorNotify(res?.data?.data?.message);
              }
            }
            setIsLoading(false);
          })
          .catch((err) => {
            setIsLoading(false);
            errorNotify("Something went Wrong!");
          });
      }
    } else {
      infoNotify("Password Mismatch!");
    }
  };

  const handleClose = () => {
    setView("login");
    setUsername("");
    setOtp(new Array(6).fill(""));
  };

  useEffect(() => {
    const isLoggedIn =
      localStorage.getItem("SWA_userRole") ||
      sessionStorage.getItem("SWA_userRole");

    if (["admin", "candidate", "client"].includes(isLoggedIn)) {
      navigate("/");
    }

    if (localStorage?.getItem("SWA_RememberPassword_loginUser") == loginUser) {
      if (localStorage?.getItem("SWA_RememberPassword") == "true") {
        setRememberPassword(
          localStorage?.getItem("SWA_RememberPassword") == "true" ? true : false
        );
        setUsername(localStorage.getItem("SWA_RememberedUsername") || "");
        setPassword(localStorage.getItem("SWA_RememberedPassword") || "");
      } else {
        setRememberPassword(false);
        setUsername("");
        setPassword("");
      }
    } else {
      setRememberPassword(false);
      setUsername("");
      setPassword("");
    }
  }, [navigate]);

  return (
    <Box sx={{ height: "100vh" }}>
      <Grid container sx={{ height: "100%" }}>
        {/* Left Side */}
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          xl={6}
          sx={{
            position: "relative",
            overflow: "hidden",
            backgroundImage: { xs: "", sm: "", md: "", lg: `url(${bglogo})` },
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundColor: "white",
            display: {
              xs: view == "login" ? "block" : "none",
              sm: view == "login" ? "block" : "none",
              md: view == "login" ? "block" : "none",
              lg: `block`,
              xl: "block",
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              zIndex: 2,
              color: "#004f9e",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              textAlign: "center",
              padding: { xs: 0, md: 0, lg: 4 },
              height: "100%",
            }}
          >
            <Box
              sx={{
                position: "relative",
                top: { xs: `20px`, md: "30px", lg: "150px" },
                mb: { xs: 0, md: 0, lg: 4 },
              }}
            >
              <img
                src={logo}
                alt="Logo"
                style={{ width: "350px", maxWidth: "100%" }}
              />
            </Box>
            <Typography
              sx={{
                position: "relative",
                display: { xs: `none`, md: "none", lg: "block" },
                top: { xs: `0px`, md: "0px", lg: "150px" },
                fontFamily: "Geist, sans-serif",
              }}
              fontWeight="bold"
            >
              Signature leads global recruitment with precision and efficiency,
              <br />
              connecting businesses worldwide with top talent tailored to their
              unique needs.
            </Typography>
            <Typography
              sx={{
                position: "relative",
                top: { xs: `0px`, md: "0px", lg: "150px" },
                display: { xs: `none`, md: "none", lg: "block" },
                fontFamily: "Geist, sans-serif",
              }}
              fontWeight="bold"
            >
              Get a call back,{" "}
              <Link
                href="#"
                style={{ color: "#004f9e", textDecoration: "none" }}
              >
                Learn more
              </Link>
            </Typography>
          </Box>
        </Grid>

        {/* Right Side */}
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          xl={6}
          sx={{
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            background: "#006CB8",
            padding: "20px",
          }}
        >
          {view == `login` && (
            <Box
              sx={{
                backdropFilter: "blur(10px)",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                boxShadow: "0 0 20px rgba(255, 255, 255, 0.1)",
                borderRadius: "16px",
                border: "2px solid rgba(255, 255, 255, 0.16)",
                padding: "40px",
                maxWidth: "450px",
                width: "100%",
              }}
            >
              <Box textAlign="center">
                <Avatar
                  src={avatar}
                  sx={{
                    height: "150px",
                    width: "150px",
                    margin: "auto",
                  }}
                />
                <Typography
                  variant="h4"
                  sx={{
                    mb: 3,
                    fontFamily: "Geist, sans-serif",
                    fontWeight: `400`,
                    fontSize: `40px`,
                    lineHeight: `100%`,
                    letterSpacing: `0%`,
                    color: "white",
                    textTransform: "capitalize",
                  }}
                >
                  Login
                </Typography>
              </Box>

              <Box
                sx={{
                  mt: 4,
                  position: { lg: "relative" },
                  bottom: { md: `0px`, lg: "50px" },
                  width: "100%",
                  maxWidth: 400,
                  padding: "20px",
                }}
              >
                <Grid container>
                  {/* Username */}
                  <Grid item xs={12} mb={2}>
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                    >
                      Username
                    </Typography>
                    <TextInput
                      placeholder="Username"
                      variant="outlined"
                      size="small"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      fullWidth
                      customStyle={{
                        background: "white",
                        border: "2px solid white",
                        borderRadius: 1,
                      }}
                    />
                  </Grid>

                  {/* Performed By */}
                  <Grid item xs={12} mb={1}>
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                    >
                      Password
                    </Typography>
                    <TextInput
                      placeholder="Password"
                      variant="outlined"
                      size="small"
                      type={"password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      fullWidth
                      customStyle={{
                        background: "white",
                        border: "2px solid white",
                        borderRadius: 1,
                      }}
                    />
                  </Grid>
                </Grid>

                <Box
                  display="flex"
                  flexWrap="wrap"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ my: 2, gap: 1 }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    sx={{ position: "relative", right: "6px" }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={rememberPassword}
                          onChange={handleRememberChange}
                          sx={{
                            color: "#fff",
                            height: "15px",
                            p: 0.5,
                            "&.Mui-checked": {
                              color: "#fff",
                            },
                          }}
                        />
                      }
                      label={
                        <Typography
                          sx={{
                            fontSize: 14,
                            fontFamily: "Geist, sans-serif",
                            fontWeight: "500",
                            color: "#fff",
                          }}
                        >
                          Remember Password
                        </Typography>
                      }
                      sx={{ m: 0 }}
                    />
                  </Box>

                  <Box>
                    <Typography
                      sx={{
                        color: "#fff",
                        fontSize: 14,
                        fontFamily: "Geist, sans-serif",
                        fontWeight: "500",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setView("forgot");
                        setUsername("");
                      }}
                    >
                      Forgot Password?
                    </Typography>
                  </Box>
                </Box>

                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    mt: 4,
                    backgroundColor: "#fff",
                    color: "#000",
                    fontWeight: "bold",
                    padding: "15px",
                    borderRadius: "10px",
                    "&.Mui-disabled": {
                      backgroundColor: "#fff", // white background when disabled
                      color: "#888", // lighter text color when disabled
                      opacity: 0.7, // slightly faded look (optional)
                    },
                  }}
                  onClick={handleLogin}
                  disabled={isLoading} // Disable button while loading
                >
                  {isLoading ? "Logging In..." : "Login"}
                </Button>
              </Box>
            </Box>
          )}

          {view == `forgot` && (
            <Box
              sx={{
                backdropFilter: "blur(10px)",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                borderRadius: "16px",
                border: "1px solid rgba(255, 255, 255, 0.17)",
                padding: "40px 30px",
                maxWidth: "450px",
                width: "100%",
              }}
            >
              <IconButton
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  color: "#fff",
                }}
              >
                <Close />
              </IconButton>
              <Box textAlign="center">
                <Typography
                  variant="h4"
                  sx={{
                    mb: 3,
                    fontFamily: "Geist, sans-serif",
                    fontWeight: `400`,
                    fontSize: `40px`,
                    lineHeight: `100%`,
                    letterSpacing: `0%`,
                    color: "white",
                    textTransform: "capitalize",
                  }}
                >
                  Forgot Password
                </Typography>
              </Box>

              <Box
                sx={{
                  mt: 4,
                  position: { lg: "relative" },
                  bottom: { md: `0px`, lg: "50px" },
                  width: "100%",
                  maxWidth: 400,
                  padding: "20px",
                }}
              >
                <TextField
                  label="Username"
                  variant="standard"
                  fullWidth
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  InputLabelProps={{
                    style: {
                      color: "#fff",
                      fontSize: "18px",
                      fontWeight: "600",
                      fontFamily: "Geist, sans-serif",
                    },
                  }}
                  InputProps={{
                    style: {
                      color: "#fff",
                      borderBottom: "2px solid white",
                      height: "55px",
                      fontFamily: "Geist, sans-serif",
                    },
                  }}
                  sx={{ my: 3 }}
                />

                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    mt: 5,
                    backgroundColor: "#fff",
                    color: "#000",
                    fontWeight: "bold",
                    padding: "15px",
                    borderRadius: "10px",
                    "&:hover": { backgroundColor: "#eee" },
                    "&.Mui-disabled": {
                      backgroundColor: "#fff", // white background when disabled
                      color: "#888", // lighter text color when disabled
                      opacity: 0.7, // slightly faded look (optional)
                    },
                  }}
                  onClick={handleForgotPassword}
                  disabled={isLoading} // Disable button while loading
                >
                  {isLoading ? "Sending OTP..." : "Send OTP"}
                </Button>
              </Box>
            </Box>
          )}

          {view == "otp" && (
            <Box
              sx={{
                backdropFilter: "blur(10px)",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                borderRadius: "16px",
                border: "1px solid rgba(255, 255, 255, 0.17)",
                padding: "40px 30px",
                maxWidth: "450px",
                width: "100%",
              }}
            >
              <IconButton
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  color: "#fff",
                }}
              >
                <Close />
              </IconButton>
              <Box textAlign="center">
                <Typography
                  variant="h4"
                  sx={{
                    mb: 3,
                    fontFamily: "Geist, sans-serif",
                    fontWeight: `400`,
                    fontSize: `40px`,
                    lineHeight: `100%`,
                    letterSpacing: `0%`,
                    color: "white",
                    textTransform: "capitalize",
                  }}
                >
                  OTP
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 1,
                  mt: 4,
                }}
              >
                {otp?.map((digit, index) => (
                  <TextField
                    key={index}
                    inputRef={(el) => (inputsRef.current[index] = el)}
                    value={digit}
                    onChange={(e) => handleChange(e.target, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    variant="outlined"
                    inputProps={{
                      maxLength: 1,
                      style: {
                        textAlign: "center",
                        fontSize: "22px",
                        fontWeight: "bold",
                        color: "#fff",
                        width: "50px",
                        height: "20px",
                        fontFamily: "Geist, sans-serif",
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "rgba(255, 255, 255, 0.5)",
                        },
                        "&:hover fieldset": {
                          borderColor: "#fff",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#fff",
                        },
                        backgroundColor: "rgba(255,255,255,0.1)",
                      },
                    }}
                  />
                ))}
              </Box>
              <Box
                sx={{
                  mt: 4,
                  position: { lg: "relative" },
                  bottom: { md: `0px`, lg: "50px" },
                  width: "100%",
                  maxWidth: 400,
                  padding: "20px",
                }}
              >
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    mt: 5,
                    backgroundColor: "#fff",
                    color: "#000",
                    fontWeight: "bold",
                    padding: "15px",
                    borderRadius: "10px",
                    "&:hover": { backgroundColor: "#eee" },
                    "&.Mui-disabled": {
                      backgroundColor: "#fff", // white background when disabled
                      color: "#888", // lighter text color when disabled
                      opacity: 0.7, // slightly faded look (optional)
                    },
                  }}
                  onClick={handleVerifyOtp}
                  disabled={isLoading} // Disable button while loading
                >
                  {isLoading ? "Verifying OTP..." : "Verify OTP"}
                </Button>
              </Box>
            </Box>
          )}

          {view == "confirmpass" && (
            <Box
              sx={{
                backdropFilter: "blur(10px)",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                // boxShadow: "0 0 20px rgba(255, 255, 255, 0.4)",
                borderRadius: "16px",
                border: "1px solid rgba(255, 255, 255, 0.17)",
                padding: "40px 30px",
                maxWidth: "450px",
                width: "100%",
              }}
            >
              <IconButton
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  color: "#fff",
                }}
              >
                <Close />
              </IconButton>

              <Box textAlign="center">
                <Typography
                  variant="h4"
                  sx={{
                    mb: 3,
                    fontFamily: "Geist, sans-serif",
                    fontWeight: `400`,
                    fontSize: `40px`,
                    lineHeight: `100%`,
                    letterSpacing: `0%`,
                    color: "white",
                    textTransform: "capitalize",
                  }}
                >
                  Reset Password
                </Typography>
              </Box>

              <Box
                sx={{
                  mt: 4,
                  position: { lg: "relative" },
                  bottom: { md: `0px`, lg: "50px" },
                  width: "100%",
                  maxWidth: 400,
                  padding: "20px",
                }}
              >
                <TextField
                  label="Password"
                  variant="standard"
                  type={showPassword ? "text" : "password"}
                  fullWidth
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  InputLabelProps={{
                    style: {
                      color: "#fff",
                      fontSize: "18px",
                      fontWeight: "600",
                      fontFamily: "Geist, sans-serif",
                    },
                  }}
                  InputProps={{
                    style: {
                      color: "#fff",
                      borderBottom: "2px solid white",
                      height: "55px",
                      fontFamily: "Geist, sans-serif",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={toggleShowPassword}
                          edge="end"
                          sx={{ color: "#fff" }}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{ mt: 1, mb: 1 }}
                />
                <TextField
                  label="Confirm Password"
                  variant="standard"
                  type={showPassword ? "text" : "password"}
                  fullWidth
                  value={ConfirmPass}
                  onChange={(e) => setConfirmPass(e.target.value)}
                  InputLabelProps={{
                    style: {
                      color: "#fff",
                      fontSize: "18px",
                      fontWeight: "600",
                      fontFamily: "Geist, sans-serif",
                    },
                  }}
                  InputProps={{
                    style: {
                      color: "#fff",
                      borderBottom: "2px solid white",
                      height: "55px",
                      fontFamily: "Geist, sans-serif",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={toggleShowPassword}
                          edge="end"
                          sx={{ color: "#fff" }}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{ mt: 1, mb: 1 }}
                />

                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    mt: 5,
                    backgroundColor: "#fff",
                    color: "#000",
                    fontWeight: "bold",
                    padding: "15px",
                    borderRadius: "10px",
                    "&:hover": { backgroundColor: "#eee" },
                    "&.Mui-disabled": {
                      backgroundColor: "#fff", // white background when disabled
                      color: "#888", // lighter text color when disabled
                      opacity: 0.7, // slightly faded look (optional)
                    },
                  }}
                  onClick={handlePasswordChange}
                  disabled={isLoading} // Disable button while loading
                >
                  {isLoading ? "Changing Password..." : "Change Password"}
                </Button>
              </Box>
            </Box>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default LoginPage;
